<template>
  <div class="embed-toggle-container">
    <div
      class="Polaris-ShadowBevel"
      style='--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ""; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);'
    >
      <div
        class="Polaris-Box mb-4"
        style="--pc-box-background:var(--p-color-bg-surface);--pc-box-min-height:100%;--pc-box-overflow-x:clip;--pc-box-overflow-y:clip;--pc-box-padding-block-start-xs:var(--p-space-400);--pc-box-padding-block-end-xs:var(--p-space-400);--pc-box-padding-inline-start-xs:var(--p-space-400);--pc-box-padding-inline-end-xs:var(--p-space-400)"
      >
        <div
          class="Polaris-InlineStack flex items-center justify-between"
          style="--pc-inline-stack-wrap:nowrap;--pc-inline-stack-flex-direction-xs:row"
        >
          <h2 class="Polaris-Text--root Polaris-Text--bodyMd">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              class="w-8 inline"
            >
              <path
                fill-rule="evenodd"
                d="M3.5 5.75a2.25 2.25 0 0 1 2.25-2.25h2.75a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2.75Zm2.25-.75a.75.75 0 0 0-.75.75v2.25h3v-3h-2.25Z"
              />
              <path
                fill-rule="evenodd"
                d="M3.5 14.25a2.25 2.25 0 0 0 2.25 2.25h2.75a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v2.75Zm2.25.75a.75.75 0 0 1-.75-.75v-2.25h3v3h-2.25Z"
              />
              <path
                fill-rule="evenodd"
                d="M14.25 16.5a2.25 2.25 0 0 0 2.25-2.25v-2.75a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2.75Zm.75-2.25a.75.75 0 0 1-.75.75h-2.25v-3h3v2.25Z"
              />
              <path
                d="M13.5 3.5a.75.75 0 0 1 .75.75v1.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0v-1.5h-1.5a.75.75 0 0 1 0-1.5h1.5v-1.5a.75.75 0 0 1 .75-.75Z"
              />
            </svg>
            Theme Store App Block
            <span
              class="Polaris-Badge"
              :class="{ 'Polaris-Badge--toneSuccess': isWidgetInstalled }"
            >
              <span class="Polaris-Text--root Polaris-Text--bodySm">{{
                isWidgetInstalled ? "ON" : "OFF"
              }}</span>
            </span>
          </h2>

          <button
            class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantSecondary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
            type="button"
            @click="openEmbedLink"
          >
            <span
              class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
              >App Block Settings</span
            >
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isWidgetInstalled: false
    };
  },
  created() {
    this.$store
      .dispatch("getWidgetInstalled")
      .then(response => {
        console.log("widget installed", response);
        if (response && response.isWidgetInstalled) {
          this.isWidgetInstalled = true;
        } else {
          this.isWidgetInstalled = false;
        }
      })
      .catch(() => {
        this.isWidgetInstalled = false;
      });
  },
  methods: {
    openEmbedLink() {
      this.$store.dispatch("getEmbedUrl").then(response => {
        window.open(response.url, "_blank");
      });
    }
  }
};
</script>

<style>
.embed-toggle-container {
  border-radius: 8px;
  border: 1px solid var(--p-border-subdued);
  background-color: var(--p-surface);
}
</style>
